import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {QuestionnairesComponent} from './questionnaires/questionnaires.component';
import {TracksComponent} from './tracks/tracks.component';
import {NavigationComponent} from './navigation/navigation.component';
import {ArticlesComponent} from "./articles/articles.component";
import {ArticleComponent} from "./article/article.component";
import {UsersComponent} from "./users/users.component";
import {PlaylistsComponent} from './playlists/playlists.component';
import {PlaylistComponent} from './playlist/playlist.component';
import {QuestionnaireReportComponent} from "./questionnaire-report/questionnaire-report.component";
import {TrackEditComponent} from "./track-edit/track-edit.component";
import {QuestionnaireEditComponent} from "./questionnaire-edit/questionnaire-edit.component";
import {ModalDeactivationGuard} from "./modal-deactivation.guard";

const routes: Routes = [
  {path: '', component: NavigationComponent},
  {path: 'questionnaires', component: QuestionnairesComponent},
  {path: 'questionnaire/new', component: QuestionnaireEditComponent, canDeactivate: [ModalDeactivationGuard]},
  {path: 'questionnaire/:id/edit', component: QuestionnaireEditComponent, canDeactivate: [ModalDeactivationGuard]},
  {path: 'report', component: QuestionnaireReportComponent},
  {path: 'tracks', component: TracksComponent},
  {path: 'track/new', component: TrackEditComponent},
  {path: 'track/:id/edit', component: TrackEditComponent},
  {path: 'articles', component: ArticlesComponent},
  {path: 'article/:id/edit', component: ArticleComponent},
  {path: 'article/new', component: ArticleComponent},
  {path: 'users', component: UsersComponent},
  {path: 'playlists', component: PlaylistsComponent},
  {path: 'playlist/new', component: PlaylistComponent},
  {path: 'playlist/:id/edit', component: PlaylistComponent}
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/app-routing.module.ts